/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentIDForm,
  AgentIDForm$Outbound,
  AgentIDForm$outboundSchema,
} from "../components/agentidform.js";

export type SuspendAgentSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SuspendAgentRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  agentIDForm: AgentIDForm;
};

/** @internal */
export type SuspendAgentSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SuspendAgentSecurity$outboundSchema: z.ZodMiniType<
  SuspendAgentSecurity$Outbound,
  SuspendAgentSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function suspendAgentSecurityToJSON(
  suspendAgentSecurity: SuspendAgentSecurity,
): string {
  return JSON.stringify(
    SuspendAgentSecurity$outboundSchema.parse(suspendAgentSecurity),
  );
}

/** @internal */
export type SuspendAgentRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  AgentIDForm: AgentIDForm$Outbound;
};

/** @internal */
export const SuspendAgentRequest$outboundSchema: z.ZodMiniType<
  SuspendAgentRequest$Outbound,
  SuspendAgentRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    agentIDForm: AgentIDForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      agentIDForm: "AgentIDForm",
    });
  }),
);

export function suspendAgentRequestToJSON(
  suspendAgentRequest: SuspendAgentRequest,
): string {
  return JSON.stringify(
    SuspendAgentRequest$outboundSchema.parse(suspendAgentRequest),
  );
}
